import moment from 'moment';
import { actionTypes, getMoreTransactionsActionTypes } from './actions';

export const getDefaultDates = () => {
  const start = moment()
    .subtract(1, 'year')
    .startOf('year');
  const end = moment();

  return {
    start,
    end,
  };
};

const initialState = {
  transactions: {},
  transactionsList: [],
  totalTransactions: 0,
  loading: false,
  error: null,
  dates: getDefaultDates(),
  selectedAccountNumber: null,
};

const handleGetMoreTransactionsRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});

const handleGetMoreTransactionsSuccess = (state, action) => ({
  ...state,
  transactions: {
    ...state.transactions,
    ...action.transactions,
  },
  totalTransactions: action.totalTransactions,
  transactionsList: action.transactionsList,
  loading: false,
  error: null,
});

const handleGetMoreTransactionsError = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
});

const handleUpdateDates = (state, action) => ({
  ...state,
  dates: action.dates,
});

const handleUpdateTransaction = (state, { transaction }) => {
  const { transactions, transactionsList } = state;
  let foundTransaction = transactions[transaction.transaction_id];
  foundTransaction = {
    ...foundTransaction,
    expense_type: transaction.expense_type,
  };
  transactions[transaction.transaction_id] = foundTransaction;

  const newTransactionsList = transactionsList.map((tr) => {
    if (tr.transaction_id === transaction.transaction_id) {
      return foundTransaction;
    }
    return tr;
  });

  return {
    ...state,
    transactions,
    transactionsList: newTransactionsList,
  };
};

export default (state = initialState, action) => {
  const handlers = {
    [actionTypes.UPDATE_DATES]: handleUpdateDates,
    [actionTypes.UPDATE_TRANSACTION]: handleUpdateTransaction,
    [getMoreTransactionsActionTypes.request]: handleGetMoreTransactionsRequest,
    [getMoreTransactionsActionTypes.success]: handleGetMoreTransactionsSuccess,
    [getMoreTransactionsActionTypes.error]: handleGetMoreTransactionsError,
  };

  return handlers[action.type]
    ? handlers[action.type](state, action)
    : state;
};
